

export enum SupportTicketPlatform {
    WEB             = 1,
    MOBILE          = 2,
    DESKTOP         = 3
}

export enum SupportTicketType {
    GENERAL             = 10,
    BUG                 = 11,
    BILLING             = 12,
    FEATURE_REQUEST     = 13,
    OTHER               = 14,
}


export const SupportTicketTypes = {
    [SupportTicketType.GENERAL]         :     {
        value: SupportTicketType.GENERAL,
        icon: "isvg-help",
        name: "General Support",
        description: "For any general inquiries or assistance with using our platform."
    },

    [SupportTicketType.BUG]:     {
        value: SupportTicketType.BUG,
        icon: "isvg-bug",
        name: "Bug Report",
        description: "Report any technical issues or glitches you've encountered."
    },

    [SupportTicketType.BILLING]: {
        value: SupportTicketType.BILLING,
        icon: "isvg-help-payment",
        name: "Billing & Payments",
        description: "Questions or concerns about invoices, payments, or subscription details."
    },

    [SupportTicketType.FEATURE_REQUEST]: {
        value: SupportTicketType.FEATURE_REQUEST,
        icon: "isvg-idea",
        name: "Feature Request",
        description: "Suggest a new feature or improvement to enhance your experience."
    },

    [SupportTicketType.OTHER] : {
        value: SupportTicketType.OTHER,
        icon: "isvg-support-mail",
        name: "Other Questions",
        description: "For anything else not covered by the categories above."
    }



}



export const SupportTicketPlatformOptions : Option[] = [
    {
        value: SupportTicketPlatform.WEB,
        label: "Web"
    },
    {
        value: SupportTicketPlatform.MOBILE,
        label: "Mobile"
    },
    {
        value: SupportTicketPlatform.DESKTOP,
        label: "Desktop"
    }
]


export const SupportTicketTypeOptions : Option[] = [
    {
        value: SupportTicketType.GENERAL,
        icon: "isvg-help",
        label: "General Support",
        helpMessage: "For any general inquiries or assistance with using our platform."
    },
    {
        value: SupportTicketType.BUG,
        icon: "isvg-bug",
        label: "Bug Report",
        helpMessage: "Report any technical issues or glitches you've encountered."
    },
    {
        value: SupportTicketType.BILLING,
        icon: "isvg-help-payment",
        label: "Billing & Payments",
        helpMessage: "Questions or concerns about invoices, payments, or subscription details."
    },
    {
        value: SupportTicketType.FEATURE_REQUEST,
        icon: "isvg-idea",
        label: "Feature Request",
        helpMessage: "Suggest a new feature or improvement to enhance your experience."
    },
    {
        value: SupportTicketType.OTHER,
        icon: "isvg-support-mail",
        label: "Other Questions",
        helpMessage: "For anything else not covered by the categories above."
    }
]
